import classnames from 'classnames'
import Image from 'next/image'
import React, { PropsWithChildren, useEffect, useRef } from 'react'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { IMAGE_FILTER } from '../../utils/detectWebPSupported'
import { FadeInWhenVisible } from '../FadeInWhenVisible'
import projectBannerStyles from '../ProjectBanner/projectBanner.module.scss'
import { ProjectVideoBanner } from './ProjectVideoBanner'

type ProjectBannerMaskProps = {
  className: string
  src: string
  mobileSrc?: string
  foregroundImage?: string
  isProjectVideo?: boolean
  videoType?: string
  videoId?: string
}

export const ProjectBannerMask:React.FC<PropsWithChildren<ProjectBannerMaskProps>> = ({
  className,
  src,
  mobileSrc,
  foregroundImage,
  children,
  isProjectVideo = false,
  videoType,
  videoId,
}) => {
  const isMobile = useMediaQuery('(max-width: 639px)')
  const parallax = useRef<HTMLDivElement>(null)
  const projectMaskRef = useRef<HTMLDivElement>(null)
  const projectBannerRef = useRef<HTMLDivElement>(null)


  useEffect(() => {
    function scrollHandler() {
      const element = parallax?.current
      const projectMaskWrap = projectMaskRef?.current
      const projectBannerRefWrapper = projectBannerRef?.current

      if (element && projectMaskWrap) {
        const offset = projectMaskWrap.getBoundingClientRect().top

        element.style.transform = `translateY(${-offset * 0.5}px)`
      }

      if (foregroundImage === '' && projectMaskWrap && projectBannerRefWrapper && !isMobile) {
        const offset = projectMaskWrap.getBoundingClientRect().top

        projectBannerRefWrapper.style.transform = `translateY(${-offset * .6}px)`
      }
    }

    window.addEventListener('scroll', scrollHandler)

    return () => window.removeEventListener('scroll', scrollHandler)
  }, [isMobile])

  return (
    <>
      <div ref={projectMaskRef} className={classnames(projectBannerStyles.projectMask, className)}  >
        <div ref={projectBannerRef}>
          {isMobile ? (
            <Image
              src={mobileSrc !== '' ? `${mobileSrc}${IMAGE_FILTER}` : `${src}${IMAGE_FILTER}`}
              width={768}
              height={803}
              objectFit="cover"
            />
          ) : (
            <Image
              src={`${src}${IMAGE_FILTER}`}
              width={4000}
              height={2083}
              objectFit="cover"
            />

          )}
        </div>
        {
          (foregroundImage && foregroundImage !== '' && !isProjectVideo) ? (
            <div ref={parallax} className={projectBannerStyles.foreGroundImageWrapper}>
              <FadeInWhenVisible
                animation="easySlidingTopFadeIn"
                transition={{ delay: isMobile ? .8 : 2.2 }}
              >
                <Image
                  src={`${foregroundImage}${IMAGE_FILTER}` || ''}
                  width={3000}
                  height={2814}
                />
              </FadeInWhenVisible>
            </div>
          ) : null
        }

        {(isProjectVideo && videoId !== '' && videoType !== undefined) ?  (
          <div className={projectBannerStyles.videoBannerWrapper}>
            <ProjectVideoBanner videoId={videoId || ''} videoType={videoType} />
          </div>
        ) : null}

      </div>
      {children}
    </>
  )
}

